<template>

	<Tickets />

</template>

<script>
import Tickets from '../components/tickets/Tickets.vue'
export default {
  components: {
    Tickets
  },
	data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

